/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { InquiryDetailResponseDto } from './inquiryDetailResponseDto';
import type { InquiryLocationItemResponseDto } from './inquiryLocationItemResponseDto';
import type { InquiryResponseDtoPropertyTypesItem } from './inquiryResponseDtoPropertyTypesItem';
import type { InquiryResponseDtoType } from './inquiryResponseDtoType';
import type { InquirySellerContactResponseDto } from './inquirySellerContactResponseDto';

export interface InquiryResponseDto {
  id: string;
  type: InquiryResponseDtoType;
  description: string;
  /** @nullable */
  priceFrom: number | null;
  /** @nullable */
  priceTo: number | null;
  propertyTypes: InquiryResponseDtoPropertyTypesItem[];
  /** @nullable */
  region: InquiryLocationItemResponseDto | null;
  /** @nullable */
  district: InquiryLocationItemResponseDto | null;
  /** @nullable */
  detail: InquiryDetailResponseDto | null;
  createdAt: string;
  sellerContact: InquirySellerContactResponseDto;
}
